import u, { createContext as w, useCallback as U, useState as b, useMemo as d, useEffect as k, useContext as g } from "react";
import { GoogleReCaptchaProvider as x } from "react-google-recaptcha-v3";
import { u as p } from "./fallback-storage-value-DraZAU_d.mjs";
import { c as C } from "./environment-nVMLUumw.mjs";
import { c as N, g as P } from "./index-CLx2OILg.mjs";
const H = "signedUpNewsletters", A = "subscribed_newsletters", V = "signedUpNewslettersUpdateTime", F = 1e4;
let s = /* @__PURE__ */ function(t) {
  return t.Archive = "archive", t.Article = "article", t.Author = "author", t.Authors = "authors", t.Homepage = "homepage", t.Live = "live", t.Others = "others", t.Page = "page", t.Plus = "plus", t.Podcast = "podcast", t.Posties = "posties", t.PostiesArticle = "article_posties", t.PostiesEvent = "event_posties", t.PostiesEvents = "events_posties", t.PostiesKids = "content", t.PostiesParents = "brochure", t.PostiesSection = "section_posties", t.PostiesVideo = "video_posties", t.Section = "section", t.Series = "series", t.StoryStyle = "story-style", t.SubSection = "subsection", t.Topic = "topic", t.Topics = "topics", t;
}({});
const $ = [s.Posties, s.PostiesArticle, s.PostiesEvent, s.PostiesEvents, s.PostiesKids, s.PostiesParents, s.PostiesSection, s.PostiesVideo];
let E = /* @__PURE__ */ function(t) {
  return t.Article = "Article", t.Page = "Page", t.Section = "Section", t.Topic = "Topic", t;
}({});
const j = {
  article: {
    paywallTypeId: "716f570e-3083-4138-a080-47d3830fafe3"
  },
  topicType: {
    newsAgenda: "news_agenda"
  }
};
function G(t) {
  if (Object.values(E).includes(t))
    return t;
}
const v = /* @__PURE__ */ w(N("SdkContext")), K = ({
  children: t,
  value: e
}) => {
  const {
    remove: i,
    set: c,
    value: n
  } = p(A, {
    defaultValue: []
  }), {
    remove: a
  } = p(V, {
    defaultValue: 0
  }), S = U((o) => {
    c(o);
  }, [c]), [l, m] = b({
    acquisitions: {},
    campaigns: {},
    myNews: {},
    topicPackageFollows: {},
    whyRegister: {}
  }), h = d(() => ({
    popupState: l,
    setPopupState: m
  }), [l]);
  k(() => {
    e.user || (i(), a());
  }, [a, i, e.user]);
  const f = d(() => {
    try {
      var o;
      return new URL(e.currentRoute, (o = P()) === null || o === void 0 ? void 0 : o.location.origin).pathname;
    } catch {
      return "";
    }
  }, [e.currentRoute]);
  return /* @__PURE__ */ u.createElement(v.Provider, {
    value: {
      ...e,
      acquisition: h,
      currentRouteWithoutQuerystring: f,
      handleSetV1SignedUpNewslettersLocalStorage: S,
      v1SignedUpNewsletters: n ?? []
    },
    "data-qa": "sdk-context-provider"
  }, /* @__PURE__ */ u.createElement(x, {
    reCaptchaKey: e.config.recaptcha.siteKey
  }, t));
};
K.displayName = "SdkContextProvider";
const I = () => {
  const {
    config: t,
    environment: e,
    ...i
  } = g(v);
  return r("facebookLikeUrl", t == null ? void 0 : t.facebook.likeUrl), r("accountsHost", t == null ? void 0 : t.accounts.host), r("graphqlHost", t == null ? void 0 : t.graphql.host), r("subscribeHost", t == null ? void 0 : t.subscribe.host), {
    ...i,
    config: t,
    environment: e ?? C({
      authOptions: {
        allowEmptyToken: !0
      },
      urlOptions: {
        headers: {
          apikey: t.graphql.apiKey
        },
        method: "POST",
        url: t.graphql.host
      }
    })
  };
}, r = (t, e) => {
  if (e)
    try {
      new URL(e);
    } catch {
      console.error(`${t} is not a valid url format, value ${e}`);
    }
};
export {
  s as P,
  F as R,
  K as S,
  V as a,
  H as b,
  E as c,
  G as d,
  $ as p,
  j as s,
  I as u
};
//# sourceMappingURL=contexts-r4a1IsAZ.mjs.map
